import React from "react";
import { faMapPin, faPlus, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Style from "./ChooseLocation.module.css";

const ChooseLocation = ({
  secondDestinationState,
  dispatch,
  originLocation,
  destinationLocation,
  destination2Location,
}) => {
  const openMapModal = (field) => {
    dispatch({ type: "OPEN_MODAL", field });
  };

  return (
    <section className={Style.ComponentHolder}>
      <div className={Style.InputHolder} onClick={() => openMapModal("origin")}>
        <FontAwesomeIcon icon={faMapPin} color="#af0060" />
        <span>مبدأ:</span>
        <input
          type="text"
          placeholder="مبدا را انتخاب کنید!"
          value={originLocation ? originLocation.address : ""}
          readOnly
        />
      </div>

      <div className={Style.InputHolder} onClick={() => openMapModal("destination")}>
        <FontAwesomeIcon icon={faMapPin} color="#af0060" />
        <span>مقصد:</span>
        <input
          type="text"
          placeholder="مقصد را انتخاب کنید!"
          value={destinationLocation ? destinationLocation.address : ""}
          readOnly
        />
      </div>

      {secondDestinationState && (
        <div className={Style.InputHolder} onClick={() => openMapModal("destination2")}>
          <FontAwesomeIcon icon={faMapPin} color="#af0060" />
          <span>مقصد دوم:</span>
          <input
            type="text"
            placeholder="مقصد دوم را انتخاب کنید!"
            value={destination2Location ? destination2Location.address : ""}
            readOnly
          />
          <FontAwesomeIcon
            icon={faTimes}
            color="#990000"
            onClick={(e) => {
              e.stopPropagation();
              dispatch({ type: "TOGGLE_SECOND_DESTINATION" });
            }}
          />
        </div>
      )}

      {!secondDestinationState && (
        <div className={Style.InputHolder} onClick={() => dispatch({ type: "TOGGLE_SECOND_DESTINATION" })}>
          <FontAwesomeIcon icon={faPlus} color="#af0060" style={{ cursor: "pointer" }} />
          <span>افزودن مقصد دوم</span>
        </div>
      )}
    </section>
  );
};

export default ChooseLocation;
